<template>
  <header :selectedEnroll="selectedEnroll" :class="{'navbar-fixed': this.$store.state.config.fixedMenu}">
    <nav class="main-menu safe-area-top"
      :style="(!selectedEnroll && !$theme.darkTheme  ? 'background: #ffffff' : { background: $theme.secondaryColor })">
      <div class="box-menu-top" v-if="!loading">
        <div v-show="!selectedEnroll">
          <div class="nav-wrapper menu-align"
            :style="(!selectedEnroll ? 'background: #ffffff' : { background: $theme.secondaryColor })">
            <!-- <img
              v-show="this.$route.name == 'my-courses'"
              :src="$appLogoSrc"
              class="valign-wrapper img-logo-header"
              alt
              srcset
            /> -->
          </div>
        </div>
        <div v-show="selectedEnroll && selectedEnroll.id" :class="{
            'nav-wrapper': true,
            'menu-align': true,

          }" :style="{background: $theme.secondaryColor}">
          <a href="javascript:;" :data-target="isDesktop ? '' : 'sidenav-1'" @click="toggleSideMenu" :class="{
              'menu-align mr1': true,
              'sidenav-trigger': !isDesktop
            }">
            <!-- <img src="@/assets/icons/menu_branco.svg" alt /> -->
            <IconMenu />
          </a>

          <a v-if="selectedEnroll && selectedEnroll.shopWindowId" href="javascript:;" :class="{ 'sidenav-close': true }" @click="navToCourse()"
            :style="(selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
            <i class="material-icons">
              home
            </i>
            <!-- <span :style="($theme.darkTheme ? 'color: white' : 'color: #333333')">
                HOME
              </span> -->
          </a>



          <img v-if="courseLogoVisible" :src="(selectedEnroll || {}).logo" class="valign-wrapper img-logo-header"
            :style="{ visibility: !loading && (selectedEnroll || {}).logo ? 'visible' : 'hidden' }" alt srcset
            @error="courseLogoVisible = false" @click="navToCourse()" />


        </div>
        <!-- <div
          class="pesquisa search-header"
          v-show="selectedEnroll && !isMobileDevice"
          :style="($theme.darkTheme ? 'background: #131318; color: #fff' : 'background: #efefef; color: #ff6600')"
        >
          <div
            class="input-field search-header-div"
            :style="($theme.darkTheme ? '' : 'color: #333333')"
          >
            <Autocomplete
              :items="autocompleteSearchData"
              item-search-property="title"
              item-label-property="title"
              :limit="15"
              :style="($theme.darkTheme ? 'color: #333333' : 'color: #333333')"
              @click="navigateToClass({ learningObjectId: $event.id})"
            ></Autocomplete>
          </div>
        </div> -->
        <div id="menu-right-group">
          <div class="viewClassroom" v-if="isPreview && selectedEnroll.classroomsList.length > 1">
            <!-- Mostrar como turma: -->
            <select name="selectClassroom" v-model="selectedClassroom" @change="selectClassroom($event)"
              class="browser-default selectClassroom">
              <option value="" disabled selected>Mostrar como turma</option>
              <option value="allClassroom">Mostrar todo o conteúdo</option>
              <option v-for="classroom in selectedEnroll.classroomsList" :key="classroom.id" :value=classroom.id>
                <span>{{ classroom.name }} <span v-if="classroom.default">(Padrão)</span></span>
              </option>
            </select>
          </div>

          <GlobalSearchBar
            v-if="selectedEnroll"
            :items="autocompleteSearchData"
            filterPropName="title"
            type="learningObjects"
            @click="navigateToClass"
          />
          <GlobalSearchBar
            v-else
            :items="enrolls"
            filterPropName="name"
            type="courses"
            @click="navigateToCourse"
          />

          <a href="javascript:;" data-target="sidenav-2" class="sidenav-trigger">
            <div class="notify-count" v-show="unreadNotifications.length > 0">{{unreadNotifications.length}}</div>
            <i :class="{'material-icons':true}"
              :style=" (selectedEnroll ? ($theme.darkTheme ? {color: $theme.secondaryText} : {color: $theme.secondaryText}) : ('color: #000'))">notifications_none</i>
          </a>

          <a href="javascript:;" data-target="sidenav-3" id="sidenav3" class="sidenav-trigger">
            <div class="menu-right-icon" :style="{ background: shopwindowPrimaryColor }">
              <img v-if="userLogoVisible" :src="$profilePic | imageHandler" class="menu-user-img" alt
                @error="userLogoVisible = false" />
              <template v-else>{{$firstLetter}}</template>
            </div>
          </a>
        </div>
      </div>
    </nav>

    <!-- LEFT SIDEBAR	 -->
    <!-- não usar v-if -> não abre o menu -->
    <ul v-show="selectedEnroll" id="sidenav-1"
      :class="{ 'sidenav':true, 'sidenav-left': true, 'sidenav-expanded': sidenavIsOpen }"
      :style="($theme.darkTheme ? 'background: #0d0d13' : 'background: #F2F3F7')">
      <li v-show="!isDesktop">
        <div class="menu-left-header safe-area-top" :style="{ background : $theme.secondaryColor}">
          <!-- <a href="javascript:;" class="left">
            <img
              :src="selectedEnroll.logo"
              class="valign-wrapper img-logo-header"
              alt
              srcset
              @error="$event.target.src = require('@/assets/images/default-course-image.png')"
              v-if="!loading && selectedEnroll"
              @click="navToCourse()"
            />
          </a> -->

          <a href="javascript:;" data-target="slide-out" class="sidenav-close right large" @click=" toggleSideMenu">
            <i class="material-icons btn-close" :style="({color: $theme.secondaryText})">close</i>
          </a>
        </div>
      </li>

      <!-- <li v-if="selectedEnroll && selectedEnroll.shopWindowId"
        :style="($theme.darkTheme ? 'background: #0d0d13' : 'background: #F2F3F7')">
        <a class="back-to-trustflix-bt" href="javascript:;" @click="navToCourse()">
          <div class="container valign-wrapper">
            <i class="material-icons" :style="({color: $theme.primaryColor})">arrow_back</i>
            <span :style="($theme.darkTheme ? 'color: white' : 'color: #333333')">
              Ir para Home
            </span>
          </div>
        </a>
      </li> -->

      <!--TODO: NÃO TEM LAYOUT PRONTO-->


      <li v-if="selectedEnroll && selectedEnroll.summary "
        :style="($theme.darkTheme ? 'background: #0d0d13' : 'background: #F2F3F7')">
        <!-- `no-progress`: com showProgress desligado pelo produtor, o título e o
             anel somem por v-if e os dois containers ficam com UM filho só — o
             botão encolhe pra largura fixa dele e o resumo, num flex com
             justify-content: center, ganha um recuo que parece defeito. A classe
             deixa o CSS tratar esse caso em vez de assumir sempre dois filhos. -->
        <div class="details" :class="{ 'no-progress': !selectedEnroll.settings.showProgress }">
          <div class="menu-progress-head">
            <div v-if="selectedEnroll.settings.showProgress" :style="({color: $theme.primaryColor})" class="menuTitle">Meu progresso</div>
          </div>
          <div class="row progress-box">

            <!-- v-tooltip.left="{
              content: formatContentProgress(),
              html: true,
              classes: 'course-progress-tooltip'
            }" -->

            <div v-if="selectedEnroll.settings.showProgress" class="popover__wrapper">
                  <a href="#">
                    <div class="popover">
                      <!-- marcador % -->
                      <svg height="96" width="96" viewBox="0 0 96 96">
                          <defs>
                            <linearGradient id="gradient">
                              <stop offset="0%" :stop-color="$theme.primaryColor" />
                              <stop offset="100%" :stop-color="$theme.primaryColor" />
                            </linearGradient>
                          </defs>
                          <circle cx="48" cy="48" r="40" stroke="#363636" stroke-width="2" stroke-linecap="round" fill="#0d0d13"
                            style="stroke-dasharray: 251; stroke-dashoffset: 0;" />
                          <circle cx="48" cy="48" r="40" stroke="url(#gradient)" stroke-width="6.5" stroke-linecap="round"
                            :fill="($theme.darkTheme ? '#0d0d13' : '#F2F3F7')" :style="{
                                'transform': 'rotate(-90deg)',
                                'transform-origin': 'center',
                                'transition': 'stroke-dashoffset 1s ease-in-out',
                                'stroke-dasharray': 251,
                                'stroke-dashoffset': courseProgress,
                                'box-shadow': '0 5px 10px 0 rgba(0, 0, 0, 0.4)',
                                }" />
                          <text x="50%" y="52%" text-anchor="middle" dominant-baseline="middle" :fill="$theme.primaryColor"
                            style="font-size:20px; font-family: robotoblack;">{{Math.ceil(selectedEnroll.progress)}}%</text>
                        </svg>

                    </div>
                  </a>
                  <div class="popover__content" v-if="!isMobileDevice"
                  :style="($theme.darkTheme ? 'background: #242424' : 'background: #ffffff')">
                    <div class="popover__message" >
                      <div class="" >
                        <ul class="course-summary-popover center">

                                <li class="liSummary" v-if="selectedEnroll.summary.modulesAmount > 0">
                                  <div class="itemSummary">
                                    <div class="itemDetail">
                                      <IconModules class="iconSummary" />
                                      <span class="text" style="opacity: 1;"
                                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.modulesAmount > 1 ?
                                        ' Módulos' : ' Módulo'}}</span>
                                    </div>

                                    <span class="number"
                                      :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.modulesAmount}}/{{selectedEnroll.summary.modulesAmount}}
                                    </span>
                                  </div>
                                </li>

                                <li v-if="selectedEnroll.summary.disciplinesAmount > 0">
                                  <div class="itemSummary">
                                    <div class="itemDetail">
                                      <IconModules class="iconSummary" />
                                      <span class="text" style="opacity: 1;"
                                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.disciplinesAmount >
                                        1 ? ' Disciplinas' : ' Disciplina'}}</span>
                                    </div>
                                    <span
                                      class="number">{{selectedEnroll.summary.disciplinesAmount}}/{{selectedEnroll.summary.disciplinesAmount}}</span>
                                  </div>
                                </li>

                                <li v-if=" selectedEnroll.summary.classesAmount > 0">
                                  <div class="itemSummary">
                                    <div class="itemDetail">
                                      <IconModules class="iconSummary" />
                                      <span class="text" style="opacity: 1;"
                                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.classesAmount > 1 ?
                                        ' Módulos' : ' Módulo'}}</span>
                                    </div>
                                    <span class="number"
                                      :style="($theme.darkTheme ? '' : 'color: #333333')">{{progressModuleDiscipline(selectedEnroll)}}</span>

                                  </div>
                                </li>

                                <li v-if=" selectedEnroll.summary.quizAmount > 0">


                                  <div class="itemSummary">
                                    <div class="itemDetail">
                                      <IconClasses class="iconSummary" />
                                      <span class="text" style="opacity: 1;"
                                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.quizAmount > 1 ?
                                        ' Quizes' : ' Quiz'}}</span>

                                    </div>
                                    <span class="number"
                                      :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.quizAmount}}/{{selectedEnroll.summary.quizAmount}}</span>

                                  </div>

                                </li>

                                <li v-if=" selectedEnroll.totalLearningObjects > 0">


                                  <div class="itemSummary">
                                    <div class="itemDetail">
                                      <IconClasses class="iconSummary" />
                                      <span class="text" style="opacity: 1;"
                                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{(selectedEnroll.totalLearningObjects) > 1
                                        ? ' Aulas' : ' Aula'}}</span>
                                    </div>
                                    <span class="number"
                                      :style="($theme.darkTheme ? '' : 'color: #333333')">{{progressLObj(selectedEnroll)}}</span>
                                  </div>


                                </li>

                                  <!-- <li v-if="selectedEnroll.summary.filesAmount > 0"> -->
                                  <!-- <li >
                                    <div class="itemSummary download" @click="$modal.show('coursefiles')">
                                      <div class="itemDetail">
                                        <IconMenuDownload class="iconSummary" />
                                        <span class="text" style="opacity: 1;" :style="($theme.darkTheme ? '' : 'color: #333333')">
                                          {{selectedEnroll.summary.filesAmount > 1 ? ' Downloads' : ' Download'}}
                                          <a href="javascript:;">

                                          </a>
                                        </span>
                                      </div>
                                      <span class="number"
                                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.filesAmount}}</span>

                                    </div>


                                  </li> -->

                        </ul>
                      </div>
                    </div>

                  </div>
                </div>
<!--            <div class="course-progress">-->
              <!-- <svg height="96" width="96" style="transform: rotate(-90deg);">
                <defs>
                  <linearGradient id="gradient">
                    <stop offset="0%" :stop-color="$theme.primaryColor" />
                    <stop offset="100%" :stop-color="$theme.primaryColor" />
                  </linearGradient>
                </defs>
                <circle cx="48" cy="48" r="40" stroke="#363636" stroke-width="2" stroke-linecap="round" fill="#0d0d13"
                  style="stroke-dasharray: 251; stroke-dashoffset: 0;" />
                <circle cx="48" cy="48" r="40" stroke="url(#gradient)" stroke-width="6.5" stroke-linecap="round"
                  :fill="($theme.darkTheme ? '#0d0d13' : '#F2F3F7')" :style="{
                      'transform': 'rotate(-90)',
                      'transition': 'stroke-dashoffset 1s ease-in-out',
                      'stroke-dasharray': 251,
                      'stroke-dashoffset': courseProgress,
                      'box-shadow': '0 5px 10px 0 rgba(0, 0, 0, 0.4)',
                      }" />
                <text x="50%" y="52%" text-anchor="middle" dominant-baseline="middle" :fill="$theme.primaryColor"
                  style="font-size:20px; font-family: robotoblack; transform: rotate(90deg); transform-origin: center center;">{{Math.ceil(selectedEnroll.progress)}}%</text>
              </svg> -->
<!--            </div>-->

            <div class="flex-center" >
              <ul class="course-summary center">

                <li v-if="isMobileDevice && selectedEnroll.summary.modulesAmount > 0">
                  <div class="itemSummary">
                    <div class="itemDetail">
                      <IconModules class="iconSummary" />
                      <span class="text" style="opacity: 1;"
                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.modulesAmount > 1 ?
                        ' Módulos' : ' Módulo'}}</span>
                    </div>

                    <span class="number"
                      :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.modulesAmount}}/{{selectedEnroll.summary.modulesAmount}}
                    </span>
                  </div>
                </li>

                <li v-if="isMobileDevice && selectedEnroll.summary.disciplinesAmount > 0">
                  <div class="itemSummary">
                    <div class="itemDetail">
                      <IconModules class="iconSummary" />
                      <span class="text" style="opacity: 1;"
                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.disciplinesAmount >
                        1 ? ' Disciplinas' : ' Disciplina'}}</span>
                    </div>
                    <span
                      class="number">{{selectedEnroll.summary.disciplinesAmount}}/{{selectedEnroll.summary.disciplinesAmount}}</span>
                  </div>
                </li>

                <li v-if="isMobileDevice && selectedEnroll.summary.classesAmount > 0">
                  <div class="itemSummary">
                    <div class="itemDetail">
                      <IconModules class="iconSummary" />
                      <span class="text" style="opacity: 1;"
                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.classesAmount > 1 ?
                        ' Módulos' : ' Módulo'}}</span>
                    </div>
                    <span class="number"
                      :style="($theme.darkTheme ? '' : 'color: #333333')">{{progressModuleDiscipline(selectedEnroll)}}</span>

                  </div>
                </li>

                <li v-if="isMobileDevice && selectedEnroll.summary.quizAmount > 0">


                  <div class="itemSummary">
                    <div class="itemDetail">
                      <IconClasses class="iconSummary" />
                      <span class="text" style="opacity: 1;"
                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.quizAmount > 1 ? '
                        Quizes' : ' Quiz'}}</span>

                    </div>
                    <span class="number"
                      :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.quizAmount}}/{{selectedEnroll.summary.quizAmount}}</span>

                  </div>

                </li>

                <li v-if="isMobileDevice && selectedEnroll.totalLearningObjects > 0">


                  <div class="itemSummary">
                    <div class="itemDetail">
                      <IconClasses class="iconSummary" />
                      <span class="text" style="opacity: 1;"
                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{(selectedEnroll.totalLearningObjects) > 1
                        ? ' Aulas' : ' Aula'}}</span>
                    </div>
                    <span class="number"
                      :style="($theme.darkTheme ? '' : 'color: #333333')">{{progressLObj(selectedEnroll)}}</span>
                  </div>


                </li>

                  <!-- No app os materiais moram na aba "Materiais" da sheet de
                       download do curso; esta entrada duplicaria o caminho.
                       Desktop e web mobile seguem abrindo o slideover. -->
                  <li v-if="selectedEnroll.summary.filesAmount > 0 && !$isApp">
                     <div class="itemSummary download" @click="$modal.show('coursefiles')">
                      <div class="itemDetail">
                        <IconMenuDownload class="iconSummary" />
                        <span class="text" style="opacity: 1;" :style="($theme.darkTheme ? '' : 'color: #333333')">
                          {{selectedEnroll.summary.filesAmount > 1 ? ' Downloads' : ' Download'}}
                          <a href="javascript:;">

                          </a>
                        </span>
                      </div>
                      <span class="number"
                        :style="($theme.darkTheme ? '' : 'color: #333333')">{{selectedEnroll.summary.filesAmount}}</span>

                    </div>


                  </li>

              </ul>
            </div>

          </div>

          <div class="row groups"
            v-show="(((selectedEnroll || {}).telegramGroups || []).length > 0 || ((selectedEnroll || {}).whatsAppGroups || []).length > 0) || ((selectedEnroll || {}).facebookGroups || []).length > 0">

            <div :style="({color: $theme.primaryColor})" class="groupsTitle">Grupos deste curso</div>
            <div class="groupBox" v-if="((selectedEnroll || {}).whatsAppGroups || []).length > 0">
              <div class="groupPlataform">
                <iconWhatsapp />
              </div>
              <div class="groupName" :style="($theme.darkTheme ? '' : 'color: #333333')">
                {{ selectedEnroll.whatsAppGroups }}
              </div>
            </div>
            <div class="groupBox" v-if="((selectedEnroll || {}).telegramGroups || []).length > 0">
              <div class="groupPlataform">
                <iconTelegram />
              </div>
              <div class="groupName" :style="($theme.darkTheme ? '' : 'color: #333333')">
                {{ selectedEnroll.telegramGroups }}
              </div>
            </div>
          </div>

          <CourseDownloadButton :enroll="selectedEnroll" width="100%" />
        </div>

      </li>
      <!-- Pesquisa -->
      <li class="pesquisa" :style="($theme.darkTheme ? 'background: #0d0d13' : 'background: #F2F3F7; color: #ff6600')">
        <div class="nav-wrapper accordion-color">
          <form>
            <div class="input-field container">
              <input id="search" type="search" placeholder="Pesquise aqui"
                :style="($theme.darkTheme ? 'color: #fff' : 'background: #F2F3F7; color: #333333')" required
                v-model="searchFilter" @input="updateFilter($event.target.value)" v-on:keydown.enter.prevent />

              <label class="label-icon" for="search">
                <i class="material-icons" :style="{ color: $theme.primaryColor }">search</i>
              </label>

              <label v-show="this.searchFilter != ''" class="label-icon-clear active" for="search"
                @click="clearSearch()">
                <i class="material-icons" :style="{ color: $theme.primaryColor}">close</i>
              </label>
            </div>
          </form>
        </div>
      </li>
      <div
        v-if="filtered && (!filtered.classes || filtered.classes.length == 0)"
        class="no-existing-filtered-classes">
        Nenhuma aula disponível.
      </div>
      <!-- Detalhes do curso -->
      <ul v-if="selectedEnroll" ref="accordion" class="classes-list collapsible collapsible-left">
        <!-- classes -->
        <template v-for="(clss, index) in (filtered && filtered.classes ? filtered.classes : [])">
        <li :id="'clss-'+ clss.id" :class="['clss-'+ clss.id , 'modules modules-left']" :data-accordion-index="index"
          :key="clss.id">
          <div class="collapsible-header no-padding module-header accordion-bg-1"
            :class="showModuleBackgroundImage ? '' : ($theme.darkTheme ? 'header-no-image-dark' : 'header-no-image-light')"
            :style="($theme.darkTheme ? '' : 'background: #F2F3F7')">
            <img v-if="showModuleBackgroundImage" :src="getClassImage(clss)" class="courseImg imgMaxWidth" alt />
            <div v-else class="module-header-no-image" :class="($theme.darkTheme ? 'no-image-dark' : 'no-image-light')"></div>
            <div class="main-module ">
              <div class="module-info">
                <!-- <div class="module-label" :style="($theme.darkTheme ? '' : 'color: #333333')">
                  <i
                    v-if="clss.state == 'Unpublished'"
                    style="font-size: 16px; margin-right: 5px; width: auto;"
                    class="material-icons"
                  >lock</i>
                  <i
                    v-if="(clss.state == 'Scheduled' && clss.releasedDate)"
                    style="font-size: 16px; margin-right: 5px; width: auto;"
                    class="material-icons"
                  >lock</i>
                  Módulo {{formatClassTitle(clss)}}
                </div> -->

                <circle-progress class="obj-progress col s1" :percent="(progressModuleTotal(clss))">
                </circle-progress>
                <span>

                </span>
                <div class="obj-separator-mod"
                  :style="($theme.darkTheme ? 'borderLeft: 1px solid #FFFFFF99' : 'borderLeft: 1px solid #c5c5c5')">
                </div>

                <div class="module-qty">
                  {{finishedTotal(clss.learningObjects)}} / {{clss.learningObjects.length}}
                </div>
              </div>

              <div class="module-name">
                <div class="line-clamp-3">{{clss.title}}</div>
              </div>
            </div>
          </div>
          <!-- Ícone de download do módulo: irmão do .module-header (não filho),
               pra não exigir position:relative no header — o que mudaria o
               containing block do .main-module e desalinharia a linha vertical.
               Ancora na .modules LI via classe .module-download-btn. -->
          <DownloadIcon
            v-if="canDownloadClass()"
            isModule
            class="module-download-btn"
            :status="getClassStatus(selectedEnroll.id, clss.id)"
            :progress="getClassDownloadedRatio(selectedEnroll.id, _downloadableLoIds(clss))"
            :disabled="isClassDownloadDisabled(clss.id)"
            @click="toggleClassDownload(clss)"
          />
          <div v-show="classRouteActive(clss)" class="collapsible-body">
            <!-- OBJETOS DE APRENDIZAGEM -->
            <ul class="collapsible">
              <li
                v-if="!clss.learningObjects || clss.learningObjects.length == 0"
                :class="[('lbj-empty-default'), 'learningObjects accordion-bg-2']"
                :style="($theme.darkTheme ? 'background: #0D0D0D' : 'background: #F2F3F7')">
                <div class="obj-details accordion-padding-3 active">
                  <i class="material-icons icons">lock</i>
                  <div class="obj-name col s8 sidenav-close line-clamp-2 unpublished"
                    :style="[($theme.darkTheme ? '' : 'color: #333333'), (true ? {color: $theme.primaryColor, fontWeight: 600} : '')]">
                    As aulas serão disponibilizadas em breve.
                  </div>
                </div>
              </li>
              <li
                :class="[('lbj-'+learningObject.id), 'learningObjects accordion-bg-2', {'active': lObjActive(learningObject)}]"
                :style="($theme.darkTheme ? 'background: #0D0D0D' : 'background: #F2F3F7')"
                v-for="(learningObject, index) in clss.learningObjects" :key="'collapsible_lo_' + learningObject.id">
                <div class="obj-details accordion-padding-3" :class="{ 'has-download-icon': loRowShowsDownload(learningObject) }">
                  <i v-if="learningObject.state == 'Unpublished'" class="material-icons">lock</i>
                  <i v-if="(learningObject.state == 'Scheduled' && learningObject.releasedDate)" class="material-icons"
                    v-tooltip.top="{content:formatLearningObjectTitle(learningObject, clss.state, clss.releasedDate)}">lock</i>
                  <CircleProgressSmall v-if="learningObject.state != 'Unpublished' && !learningObject.releasedDate"
                    class=" obj-progress-small small col s1" :percent="learningObject.progress"
                    @change="(e)=>progressObjChange(e.target.checked, selectedEnroll, learningObject, clss)"></CircleProgressSmall>

                  <div v-if="(index+1) != (clss.learningObjects.length )" class="obj-separator"
                    :style="($theme.darkTheme ? 'borderLeft: 1px solid #FFFFFF99' : 'borderLeft: 1px solid #c5c5c5')">
                  </div>

                  <div class="obj-text">
                    <div class="obj-name col s8 sidenav-close line-clamp-2"
                      :style="($theme.darkTheme ? '' : 'color: #333333'), (lObjActive(learningObject) ? {color: $theme.primaryColor, fontWeight: 600} : '')"
                      :class="[(learningObject.state == 'Unpublished' || (learningObject.state == 'Scheduled' && learningObject.releasedDate) ? 'unpublished' : '') ]"
                      @click="navigateToClass({courseId:selectedEnroll.courseId,moduleId:0,disciplineId:clss.disciplineId,classId:clss.id,learningObjectId:learningObject.id})">
                      {{learningObject.title}}</div>
                    <div class="obj-time col s2" :style="($theme.darkTheme ? '' : 'color: #333333')">
                      {{learningObjectMeta(learningObject)}}</div>
                  </div>
                  <DownloadIcon
                    v-if="loRowShowsDownload(learningObject)"
                    :status="getLearningObjectStatus(selectedEnroll.id, learningObject.id)"
                    :progress="getEffectiveProgress(selectedEnroll.id, learningObject.id)"
                    :has-partial="hasPartialDownload(selectedEnroll.id, learningObject.id)"
                    :disabled="isLoDownloadDisabled(learningObject.id)"
                    @click="toggleLearningObjectDownload(learningObject.id, learningObject.title)"
                  />
                </div>
              </li>
            </ul>
          </div>
        </li>
        <!-- Story-6066: recomendação de upsell/downsell logo após o 1º
             módulo (uma por vez, em rodízio — ver store/modules/recommendation). Deslocam o índice DOM dos
             módulos seguintes — por isso o scrollToCurrentLearningObject usa
             a posição real do LI, não o data-accordion-index. -->
        <template v-if="index === 0">
          <RecommendationMenuItem
            v-for="rec in menuRecommendations"
            :key="'recommendation_' + rec.offerId"
            :product="rec" />
        </template>
        </template>

        <!-- Módulos -->
        <template v-for="(mod, modIndex) in (filtered && filtered.modules ? filtered.modules : [])">
        <li :class="{'modules':true, 'active': classRouteActive(mod), 'show-specific-class': classRouteActive(mod)}"
          :key="'collpasible_mod_' + mod.id">
          <div class="collapsible-header no-padding module-header accordion-bg-1"
            :class="showModuleBackgroundImage ? '' : ($theme.darkTheme ? 'header-no-image-dark' : 'header-no-image-light')"
            :style="($theme.darkTheme ? '' : 'background: #F2F3F7')">
            <img v-if="showModuleBackgroundImage" :src="getModuleImage(mod)" class="courseImg imgMaxWidth" alt />
            <div v-else class="module-header-no-image" :class="($theme.darkTheme ? 'no-image-dark' : 'no-image-light')"></div>
            <div class="main-module container">
              <div class="module-info">
                <!-- <div class="module-label" :style="($theme.darkTheme ? '' : 'color: #333333')">Módulo</div> -->
                <div class="module-qty" :style="($theme.darkTheme ? '' : 'color: #333333')">
                  {{progressModuleDiscipline(mod)}}</div>
              </div>

              <div class="module-name" :style="($theme.darkTheme ? '' : 'color: #000; fontWeight: 500')">
                <div class="line-clamp-3">{{mod.name}}</div>
              </div>
            </div>
          </div>
          <div v-show="classRouteActive(mod)" class="collapsible-body accordion-bg-2 menu-aco">
            <!-- NÍVEL 2 - AULAS -->
            <ul class="collapsible">
              <!-- Aula -->
              <li :class="{'classes':true, 'active': classRouteActive(clss)}" v-for="clss in mod.classes"
                :key="'collapsible_class_' + clss.id">
                <div :class="{'collapsible-header':true, 'classes-header':true, 'container':true, 'transparent':true}">
                  <div class="classes-info">
                    <div class="classes-name">
                      <i class="material-icons iconadd">add</i>
                      <i class="material-icons iconremove">remove</i>
                      {{clss.title}}
                    </div>
                    <div class="classes-qty">{{finishedTotal(clss.learningObjects)}}/{{clss.learningObjects.length}}
                    </div>
                    <DownloadIcon
                      v-if="canDownloadClass()"
                      :status="getClassStatus(selectedEnroll.id, clss.id)"
                      :progress="getClassDownloadedRatio(selectedEnroll.id, _downloadableLoIds(clss))"
                      :disabled="isClassDownloadDisabled(clss.id)"
                      @click="toggleClassDownload(clss)"
                    />
                  </div>
                </div>
                <div v-show="classRouteActive(clss)" class="collapsible-body">
                  <!-- NÍVEL 3 - OBJETOS DE APRENDIZAGEM -->
                  <ul class="collapsible">
                    <!-- Objeto de Aprendizagem -->
                    <li class="learningObjects accordion-bg-3" v-for="learningObject in clss.learningObjects"
                      :key="'collapsible_lo_' + learningObject.id">
                      <div :class="{'active': classRouteActive(clss), 'has-download-icon': loRowShowsDownload(learningObject)}"
                        class="obj-details container accordion-padding-3">
                        <circle-progress class="obj-progress col s1" :percent="learningObject.progress"
                          :icon="menuIcon(learningObject)"
                          @change="(e)=>progressObjChange(e.target.checked, selectedEnroll, learningObject, clss)"></circle-progress>

                        <div class="obj-text">
                          <div class="obj-name col s8 sidenav-close line-clamp-3"
                            :style="($theme.darkTheme ? '' : 'color: #333333'), (lObjActive(learningObject) ? {color: $theme.primaryColor, fontWeight: 600} : '')"
                            @click="navigateToClass({courseId:selectedEnroll.courseId,moduleId:mod.id,disciplineId:clss.disciplineId,classId:clss.id,learningObjectId:learningObject.id})">
                            {{learningObject.title}}</div>
                          <div class="obj-time col s2" :style="($theme.darkTheme ? '' : 'color: #333333')">
                            {{learningObjectMeta(learningObject)}}</div>
                        </div>
                        <DownloadIcon
                          v-if="loRowShowsDownload(learningObject)"
                          :status="getLearningObjectStatus(selectedEnroll.id, learningObject.id)"
                          :progress="getEffectiveProgress(selectedEnroll.id, learningObject.id)"
                          :has-partial="hasPartialDownload(selectedEnroll.id, learningObject.id)"
                          :disabled="isLoDownloadDisabled(learningObject.id)"
                          @click="toggleLearningObjectDownload(learningObject.id, learningObject.title)"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </li>
        <template v-if="modIndex === 0 && !(filtered.classes && filtered.classes.length)">
          <RecommendationMenuItem
            v-for="rec in menuRecommendations"
            :key="'recommendation_mod_' + rec.offerId"
            :product="rec" />
        </template>
        </template>
      </ul>
    </ul>
    <!-- RIGHT SIDEBAR - NOTIFICAÇÕES -->
    <NotificationsPanel
      id="sidenav-2"
      :dark="!!selectedEnroll && !!$theme.darkTheme"
      :accent="!selectedEnroll ? '#0564b1' : $theme.primaryColor"
    />
    <!-- RIGHT SIDEBAR - MENU	-->
    <ul id="sidenav-3" :class="{'sidenav':true, 'side-right':true}"
      :style=" (selectedEnroll ? ($theme.darkTheme ? 'background: #0d0d13' : 'background: #ffffff') : ('background: #ffffff'))">
      <div class="menu-right-items">
      <li v-show="selectedEnroll">
        <div :class="{'user-view':false, 'center-align':true, 'menu-right-header':true, 'safe-area-top':true}"
          :style="{ background : $theme.secondaryColor}">
          <img class="img-logo-header-g" :src="selectedEnroll.image" alt
            v-if="!loading && selectedEnroll && courseLogoVisible" @error="courseLogoVisible = false" />
        </div>

      </li>

      <li v-show="!selectedEnroll">
        <div :class="{'user-view':false, 'center-align':true, 'menu-right-header':true, 'safe-area-top':true}">
          <img class="img-logo-header-g" :src="$appLogoSrc" alt />
        </div>
      </li>
      <!-- ESCONDER NA PAGINA DE CURSOS -->
      <li v-show="selectedEnroll">
        <a href="javascript:;" :class="{ 'sidenav-close':true}" @click="navToCourse()"
          :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
          <i class="material-icons">
            <IconHome />
          </i>
          Página inicial
        </a>
      </li>
      <li>
        <a href="javascript:;" :class="{ 'sidenav-close':true }" @click="showModal('profile')"
          :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
          <i class="material-icons">
            <!-- <img src="@/assets/icons/user.svg" alt /> -->
            <IconProfile :selectedEnroll="selectedEnroll" />
          </i>
          Perfil
        </a>
      </li>
      <!-- ESCONDER NA PAGINA DE CURSOS -->

      <li v-show="(selectedEnroll && selectedEnroll.shopWindowId) || uniqueShopWindowId">
        <a href="javascript:;" :class="{ 'sidenav-close':true }"
           @click="navToCourse(!selectedEnroll ? uniqueShopWindowId : undefined)"
           :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
          <!-- <i class="material-icons" :style="(!selectedEnroll ? 'color: #0564b1' : {color: $theme.primaryColor})">play_arrow</i> -->
          <i class="material-icons">
            <!-- <img src="@/assets/icons/book.svg" alt /> -->
            <IconTrustflix />
          </i>
          Home
        </a>
      </li>
      <li v-show="(selectedEnroll || $route.name === 'my-downloads') && !uniqueShopWindowId">
        <a href="javascript:;" :class="{ 'sidenav-close':true}" @click="navTo('/p/my-courses')"
          :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
          <i class="material-icons">
            <!-- <img src="@/assets/icons/book.svg" alt /> -->
            <IconMyCourses />
          </i>
          Meus Cursos
        </a>
      </li>
      <li v-if="$isApp">
        <a href="javascript:;" :class="{ 'sidenav-close':true}" @click="navTo('/p/my-downloads')"
          :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
          <i class="material-icons">
            <IconMenuMyDownloads :selectedEnroll="selectedEnroll" />
          </i>
          Meus Downloads
        </a>
      </li>
      <li v-if="isConnected">
        <a href="javascript:;" :class="{ 'sidenav-close':true }" @click="openSubscriptionUrl()"
           :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
          <i class="material-icons">
            <IconDocument />
          </i>
          Gerenciar Assinaturas
        </a>
      </li>
      <li>
        <a href="javascript:;" :class="{ 'sidenav-close':true}" @click="showModal('configuration')"
          :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
          <i class="material-icons">
            <IconConfig :selectedEnroll="selectedEnroll" />
          </i>
          Configurações
        </a>
      </li>
      <!-- ESCONDER NA PAGINA DE CURSOS -->
      <li v-show="selectedEnroll">
        <a href="javascript:;" :class="{ 'sidenav-close':true}" @click="showModal('notes')"
          :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
          <i class="material-icons">
            <!-- <img src="@/assets/icons/notes-2.svg" alt /> -->
            <IconNotes />
          </i>
          Anotações
        </a>
      </li>
      <!-- Silenciar avisos deste curso (STORY-1642, N5). Só no app, com o push
           ativo neste build e as preferências carregadas (precisamos da lista
           completa para o PUT). -->
      <li v-if="$isApp && selectedEnroll && pushAvailable && pushPreferencesLoaded">
        <a href="javascript:;" :class="{ 'sidenav-close':true, 'menu-item-wrap': true }" @click="toggleCourseMute()"
          :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
          <i class="material-icons">
            <IconBellAlert v-if="currentCourseMuted" />
            <IconBellOff v-else />
          </i>
          {{ currentCourseMuted ? 'Reativar avisos deste curso' : 'Silenciar avisos deste curso' }}
        </a>
      </li>


      <li
        v-show="(((selectedEnroll || {}).telegramGroups || []).length > 0 || ((selectedEnroll || {}).whatsAppGroups || []).length > 0) || ((selectedEnroll || {}).facebookGroups || []).length > 0">
        <a href="javascript:;" :class="{ 'sidenav-close':true}" @click="showModal('mygroup')"
          :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
          <i class="material-icons">
            <!-- <img src="@/assets/icons/notes-2.svg" alt /> -->
            <IconMyGroup />
          </i>
          Meus Grupos
        </a>
      </li>


      <li v-show="emiteCertificado">
        <a href="javascript:;" :class="{ 'sidenav-close':true}" @click="showModal('mycertificate')"
          :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
          <i class="material-icons icon-certificate">
            <!-- <img src="@/assets/icons/notes-2.svg" alt /> -->
            <IconMyCertificate />
          </i>
          Meus Certificados
        </a>
      </li>

      <!-- <li>
          <a
            href="javascript:;"
            :class="{ 'sidenav-close':true}"
            @click="showModal('support')"
           :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333'))"
          >
             <i class="material-icons" >
              <img src="@/assets/icons/help-circle.svg" alt />
            </i>
            Suporte
          </a>
      </li>-->
      </div>
      <div class="menu-right-footer">
        <div>
          <ul>
            <li>
              <a href="javascript:;" @click="logout()"
                :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))">
                <i class="material-icons">
                  <!-- <img src="@/assets/icons/log-out.svg" alt /> -->
                  <IconLogout :selectedEnroll="selectedEnroll" />
                </i>
                Sair
              </a>
            </li>
          </ul>
        </div>
        <div class="footer-version"
          :style=" (selectedEnroll ? ($theme.darkTheme ? 'color: #ffffff' : 'color: #333333') : ('color: #333333'))"
          :title="'Tema: ' + layoutTheme">{{version}}</div>
      </div>
    </ul>

  </header>
</template>

<script>
import Autocomplete
  from "@/components/Autocomplete";

import CircleProgress
  from "@/components/CircleProgress";
import CircleProgressSmall
  from "@/components/CircleProgressSmall";
import CourseDownloadButton
  from "@/components/CourseDownloadButton";
import DownloadIcon
  from "@/components/DownloadIcon";
import GlobalSearchBar
  from "@/components/GlobalSearchBar/index.vue";
import RecommendationMenuItem
  from "@/components/ProductRecommendation/RecommendationMenuItem.vue";
import recommendationsMixin
  from "@/mixins/recommendations";

import IconBellAlert
  from "@/components/UI/IconBellAlert.vue";
import IconBellOff
  from "@/components/UI/IconBellOff.vue";
import IconClasses
  from "@/components/UI/IconClasses";
import IconConfig
  from "@/components/UI/IconConfig";
import IconDocument
  from "@/components/UI/IconDocument.vue";
import IconHome
  from "@/components/UI/IconHome";
import IconLogout
  from "@/components/UI/IconLogout";
import IconMenu
  from "@/components/UI/IconMenu";
import IconMenuDownload
  from "@/components/UI/IconMenuDownload";
import IconMenuMyDownloads
  from "@/components/UI/IconMenuMyDownloads";
import IconModules
  from "@/components/UI/IconModules";
import IconMyCertificate
  from "@/components/UI/IconMyCertificate";
import IconMyCourses
  from "@/components/UI/IconMyCourses";
import IconMyGroup
  from "@/components/UI/IconMyGroup";

import IconNotes
  from "@/components/UI/IconNotes";
import IconProfile
  from "@/components/UI/IconProfile";
import IconSync
  from "@/components/UI/IconSync.vue";
import IconTelegram
  from "@/components/UI/IconTelegram";
import IconTrustflix
  from "@/components/UI/IconTrustflix";
import IconWhatsapp
  from "@/components/UI/IconWhatsapp";
import {
  formatDate
} from "@/filters/formatDate";
import downloadActions
  from "@/mixins/downloadActions";
import subscriptionUrlMixin
  from "@/mixins/subscriptionUrl";
import M
  from "materialize-css";
import {
  isMobile
} from "mobile-device-detect";
import {
  mapGetters,
  mapState
} from "vuex";
import {
  AuthService
} from "../services/auth.service";
import {
  ShopWindowsService
} from "../services/shopWindow.service";
import NotificationsPanel
  from "@/components/NotificationsPanel";


export default {
  name: "Header",
  props: ["layoutTheme", "coursePreview"],
  mixins: [subscriptionUrlMixin, downloadActions, recommendationsMixin],
  components: {
    NotificationsPanel,
    RecommendationMenuItem,
    IconSync,
    IconDocument,
    GlobalSearchBar,
    CircleProgress,
    CircleProgressSmall,
    DownloadIcon,
    CourseDownloadButton,
    Autocomplete,
    IconHome,
    IconProfile,
    IconMyCourses,
    IconMenuMyDownloads,
    IconTrustflix,
    IconBellAlert,
    IconBellOff,
    IconConfig,
    IconNotes,
    IconMyGroup,
    IconMyCertificate,
    IconLogout,
    IconMenu,
    IconClasses,
    IconMenuDownload,
    IconModules,
    IconWhatsapp,
    IconTelegram
  },
  data() {
    return {
      show: false,
      searchFilter: "",
      userLogoVisible: true,
      courseLogoVisible: true,
      loading: true,
      version: process.env.VUE_APP_APP_VERSION,
      leftMenuRef: null,
      sidenavScrollTimer: null,
      showSpecificClass: null,
      showSpecificLearningObject: null,
      accordionRef: null,
      isDesktop: false,
      selectedClassroom: "",
      // Guard contra empilhamento do modal de confirmação cellular. User
      // clicando rápido em N aulas antes de confirmar abriria N modals com
      // proceed callbacks diferentes — confuso. Setado true ao abrir, false
      // em qualquer caminho de fechamento (confirm/cancel/before-close).
      // Estado da sheet de qualidade de download. Resolver fica guardado
      // aqui pra que `_promptDownloadQuality` consiga resolver a Promise
      // quando o user escolhe/cancela na sheet (sem Vuex global).
    };
  },
  computed: {
    // Story-6066 — some durante a busca para não aparecer como "resultado".
    menuRecommendations() {
      if (this.searchFilter) return [];
      return this.recommendations;
    },
    // Chave de "acesso": muda ao entrar no curso, na aula, ao trocar de
    // matrícula ou ao voltar a rede. Trocar de aula dentro do mesmo curso NÃO
    // muda a chave — não precisa rebuscar a cada aula.
    recommendationFetchKey() {
      if (this.recommendationsBlocked) return null;
      // Só busca quando a matrícula da rota já é a atual. O X-ApplicationId é
      // default GLOBAL do axios, setado no enroll/setCurrentEnroll — que roda no
      // mounted da página, DEPOIS do watcher immediate deste header (irmão
      // anterior do <router-view>). Sem esta espera, F5/deep link saía sem o
      // header (400) e a troca de aula entre matrículas saía com o appId da
      // anterior (404), e a chave não mudava de novo para rebuscar.
      if (!this.selectedEnroll ||
        String(this.selectedEnroll.id) !== String(this.recommendationEnrollId)) {
        return null;
      }
      return this.$route.name + "|" + this.recommendationEnrollId;
    },
    ...mapState({
      selectedEnroll: (state) => state.enroll.current,
      enrolls: (state) => state.enroll.enrolls,
      isPreview: (state) => state.enroll.isPreview,
      currentProfile: (state) => state.user.currentUser,
      sidenavIsOpen: (state) => state.config.sidenavIsOpen,
      shopWindow: (state) => state.shopWindow,
      notifications: (state) => state.notification.notifications,
      subscriptions: (state) => state.subscription.subscriptions,
      drmConfig: (state) => state.learningObject.drm,
      downloadQualityWifi: (state) => state.download.downloadQualityWifi,
      downloadQualityLastCellular: (state) => state.download.downloadQualityLastCellular,
    }),
    ...mapGetters({
      isConnected: 'dom/isConnected',
      filtered: "enroll/filtered",
      autocompleteSearchData: "enroll/autocomplete",
      isLearningObjectDownloaded: "download/isLearningObjectDownloaded",
      isClassDownloaded: "download/isClassDownloaded",
      getLearningObjectStatus: "download/getLearningObjectStatus",
      getLearningObjectProgress: "download/getLearningObjectProgress",
      getClassStatus: "download/getClassStatus",
      getClassProgress: "download/getClassProgress",
      getClassDownloadedRatio: "download/getClassDownloadedRatio",
      hasPartialDownload: "download/hasPartialDownload",
      getPartialDownload: "download/getPartialDownload",
      getEffectiveProgress: "download/getEffectiveProgress",
      connectionType: "dom/connectionType",
      downloadOnCellular: "download/getDownloadOnCellular",
      cellularConfirmedThisCycle: "download/isCellularConfirmedThisCycle",
    }),
    showModuleBackgroundImage() {
      // Cursos legados não têm o campo nas settings — o padrão é exibir a imagem dos módulos.
      var settings = (this.selectedEnroll && this.selectedEnroll.settings) || {};
      return settings.showModuleBackgroundImage !== false;
    },
    pushAvailable() {
      return this.$store.getters["push/isAvailable"];
    },
    pushPreferencesLoaded() {
      return this.$store.state.push.preferencesLoaded;
    },
    currentCourseMuted() {
      return Boolean(this.selectedEnroll && this.$store.getters["push/isCourseMuted"](this.selectedEnroll.courseId));
    },
    unreadNotifications() {
      if (this.notifications) {
        return this.notifications.filter((not) => {
          return not.readOn == null;
        });
      }
      return false;
    },
    isMobileDevice() {
      return isMobile;
    },
    courseProgress() {
      return 251 - (251 * this.selectedEnroll.progress) / 100;
    },
    emiteCertificado(){
      if (!this.selectedEnroll) return
      if (this.selectedEnroll.settings.enableCertificate) {
        return true;
        }
    },
    uniqueShopWindowId() {
      // gets unique shopWindow Id
      if (!this.enrolls) return
      const firstProducer = this.enrolls[0];
      if (
        firstProducer?.shopWindowId &&
        this.enrolls.every(
          (item) =>
            item.applicationId === firstProducer?.applicationId &&
            item.shopWindowId
        )
      )
        {
          return firstProducer.shopWindowId;
        }

      return false
    },
    shopwindowPrimaryColor() {
      return this.selectedEnroll &&
        this.selectedEnroll?.shopWindowId === this.shopWindow?.id
        ? this.shopWindow.primaryColor
        : undefined;
    }
  },
   updated() {
    this.$nextTick(() => {
      this.refreshAccordion();
      //TODO: comentado, mas não houve muidança de coportamento aparente!
      //this.refreshRightNav();

    });
  },
  async mounted() {
    this.MaterializeInits();
    this.handleWindowResize();
    this.clearSearch();
    this.$store.dispatch("config/setSidenavState", true);
    this.$store.state.config.fixedMenu = true;
    // document.querySelector('header').style.display = 'block';
    // navbar-fixed

    this.loading = false;
    window.addEventListener('resize', this.handleWindowResize);

    if (this.selectedEnroll) this.onOpenLeftNav();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize);
    clearTimeout(this.sidenavScrollTimer);
  },
  watch: {
    filtered() {
      this.refreshAccordion();
    },
    // A API recalcula a cada acesso (sem cache), então busca de novo sempre
    // que a chave muda. Bloqueado (offline/preview/aula baixada) → null, não busca.
    recommendationFetchKey: {
      immediate: true,
      handler(key) {
        if (!key) return;
        this.$store.dispatch("recommendation/fetch", this.recommendationEnrollId);
      },
    },
    $route(to, from) {
      this.MaterializeInits();


      switch (to.name) {
        case "class":
          const enrollId = to.params.enrollId;
          const learningObjectId = to.params.id;
          break;
      }
    },
    $profilePic() {
      this.userLogoVisible = true;
    },
    selectedEnroll(value) {
      this.courseLogoVisible = true;

      // Carrega DRM antes do user entrar numa aula — sem isso o gate de
      // download na sidebar renderiza com drmConfig=null. Dedup por
      // courseId porque selectedEnroll é re-emitido em várias situações.
      const courseId = value && value.courseId;
      if (courseId && this._lastDrmCourseId !== courseId) {
        this._lastDrmCourseId = courseId;
        this.$store.dispatch('learningObject/getDRM', courseId);
      }

      const routesWithoutCourseTheme = ['my-courses', 'trustflix'];
      if (routesWithoutCourseTheme.includes(this.$route.name)) {
        this.$nextTick(() => {
          this.MaterializeInits();
        });
        return;
      }

      if (value) {

        const newTheme = {
          darkTheme: value.settings.darkMode,
          primary: value.settings.primaryColor,
          secondary: value.settings.secondaryColor
        };

        this.$updateTheme(newTheme);
        this.$nextTick(() => {
          this.MaterializeInits();
          this.$forceUpdate();
        });
      }
    }
  },
  methods: {
    // Delega ao mixin: é exatamente o mesmo gesto do botão na página da aula.
    toggleLearningObjectDownload(id, name) {
      this.toggleLoDownload({
        enrollId: this.selectedEnroll.id,
        lo: this._findLO(id),
        name
      });
    },

    // Versão de TURMA do toggleLoDownload. Não dá pra reusar o do mixin porque
    // a unidade aqui é o lote (removeClass/downloadClass, e o estado agregado
    // da turma não tem 'queued' — vai direto pra 'downloading' no clique).
    async toggleClassDownload(clss) {
      const enrollId = this.selectedEnroll.id;
      const fullClss = this._findFullClass(clss.id) || clss;
      const learningObjectIds = (fullClss.learningObjects || []).map(lo => lo.id);
      const className = fullClss.name || fullClss.title;
      const remove = () => this.$store.dispatch('download/removeClass', { enrollId, id: clss.id, learningObjectIds });

      if (this.getClassStatus(enrollId, clss.id) === 'downloading') {
        if (await this.confirmCancelDownload(className)) remove();
        return;
      }

      if (this.isClassDownloaded(enrollId, clss.id)) {
        if (await this.confirmRemoveDownload(className)) remove();
        return;
      }

      if (!(await this.ensureCellularAllowed(className))) return;

      // Tem vídeo se ao menos 1 LO da turma tem broadcast — define se a sheet
      // de qualidade deve abrir (PDFs sozinhos não pedem qualidade).
      const hasVideo = (fullClss.learningObjects || []).some(lo => lo && lo.broadcast);
      const quality = await this.resolveDownloadQuality({ hasVideo });
      if (quality === null) return;
      this.$store.dispatch('download/downloadClass', { enrollId, id: clss.id, learningObjectIds, className, quality });
    },
    // Espelha exatamente o v-if do DownloadIcon nas linhas de LO. Usado também
    // pela classe `has-download-icon` (padding/stacking só quando o ícone existe).
    loRowShowsDownload (learningObject) {
      return !!learningObject &&
        learningObject.state !== 'Unpublished' &&
        !learningObject.releasedDate &&
        this._canDownloadLO(learningObject);
    },
    // Esconde (em vez de grayed-out) quando: flag DRM ampla, flag DRM de PDF,
    // ou LO exclusivamente online (quiz/external sem broadcast/pdf/html).
    // Checagem de codCurso evita falso-positivo com DRM cacheado de outro curso.
    _canDownloadLO (learningObject) {
      // Regra única no mixin downloadActions — o botão na página da aula
      // (StudentClass) precisa exatamente da mesma resposta que este ícone.
      return this.canDownloadLo(learningObject, this.selectedEnroll && this.selectedEnroll.courseId);
    },
    _downloadableLoIds (clss) {
      return ((clss && clss.learningObjects) || [])
        .filter(lo => this._canDownloadLO(lo))
        .map(lo => lo.id);
    },
    canDownloadClass () {
      // Download offline depende do filesystem/plugin nativo — não existe no web.
      if (!this.$isApp) return false;

      const cfg = this.drmConfig;
      const courseId = this.selectedEnroll && this.selectedEnroll.courseId;
      return !(cfg && cfg.codCurso == courseId && cfg.desabilitarDownloadAulas === true);
    },
    // Estar offline só impede COMEÇAR um download. Cancelar um que está em
    // curso (ou na fila) segue permitido — senão uma queda de rede trava o
    // ícone e o usuário não consegue nem desistir.
    isLoDownloadDisabled (loId) {
      if (this.isConnected) return false;
      const st = this.getLearningObjectStatus(this.selectedEnroll.id, loId);
      if (st === 'downloading' || st === 'queued') return false;
      return !this.isLearningObjectDownloaded(this.selectedEnroll.id, loId);
    },
    isClassDownloadDisabled (classId) {
      if (this.isConnected) return false;
      if (this.getClassStatus(this.selectedEnroll.id, classId) === 'downloading') return false;
      return !this.isClassDownloaded(this.selectedEnroll.id, classId);
    },
    _findFullClass(classId) {
      const directClass = (this.selectedEnroll.classes || []).find(c => c.id === classId);
      if (directClass) return directClass;

      for (const mod of (this.selectedEnroll.modules || [])) {
        const inModule = (mod.classes || []).find(c => c.id === classId);
        if (inModule) return inModule;
        for (const disc of (mod.disciplines || [])) {
          const inDisc = (disc.classes || []).find(c => c.id === classId);
          if (inDisc) return inDisc;
        }
      }

      for (const disc of (this.selectedEnroll.disciplines || [])) {
        const inDisc = (disc.classes || []).find(c => c.id === classId);
        if (inDisc) return inDisc;
      }

      return null;
    },
    // Acha 1 learning object pelo id varrendo todas as estruturas (classes,
    // modules.classes, modules.disciplines.classes, disciplines.classes).
    // Usado pelo gate de qualidade pra detectar se a aula tem broadcast (vídeo).
    _findLO(loId) {
      const classes = [];
      classes.push(...(this.selectedEnroll.classes || []));
      for (const mod of (this.selectedEnroll.modules || [])) {
        classes.push(...(mod.classes || []));
        for (const disc of (mod.disciplines || [])) {
          classes.push(...(disc.classes || []));
        }
      }
      for (const disc of (this.selectedEnroll.disciplines || [])) {
        classes.push(...(disc.classes || []));
      }
      for (const cls of classes) {
        const lo = (cls.learningObjects || []).find(l => l && l.id === loId);
        if (lo) return lo;
      }
      return null;
    },
      selectClassroom(event){
          this.classRoom = event.target.value;

          if (this.classRoom == "allClassroom"){
              this.resetDefault();
              return;
          }
          this.refreshSelectedClassroom();
      },

      refreshSelectedClassroom(){
        if (!this.selectedEnroll) return;
        this.resetDefault();

        for (let i = 0; i < this.selectedEnroll.classes.length; i++) {
          var module = this.selectedEnroll.classes[i];

          for (let t = 0; t <= module.classroom.length; t++) {
              var classroomModule = module.classroom[t];
              var moduleId = "clss-" + module.id;
              var contentId = "content-" + module.id;

              if (this.classRoom != classroomModule){
                 document.getElementById(moduleId).classList.add('hide')
                 document.getElementById(contentId).classList.add('hide')
              }else{
                 document.getElementById(moduleId).classList.remove('hide')
                 document.getElementById(contentId).classList.remove('hide')
                break;
              }
          }
          }
      },
    resetDefault(){
          if (!this.selectedEnroll) return;
          for (let i = 0; i < this.selectedEnroll.classes.length; i++) {
            var moduleId = "clss-" + this.selectedEnroll.classes[i].id;
            var contentId = "content-" + this.selectedEnroll.classes[i].id;
            document.getElementById(moduleId).classList.remove('hide')
            document.getElementById(contentId).classList.remove('hide')
          }
      },
    MaterializeInits() {
      this.refreshAccordion();

      this.refreshLeftNav();

      this.refreshRightNav();

      this.selectClassroomPreview();
    },
    refreshAccordion() {
      var collLeft = document.querySelectorAll(".collapsible-left");
      this.leftMenuAccordionRef = M.Collapsible.init(collLeft, {
        accordion: true,
        // O accordion fecha o modulo anterior, entao abrir um modulo mais
        // abaixo apaga a altura do painel de cima e a lista inteira escorrega
        // por baixo de um scrollTop que nao mudou — o modulo clicado sobe
        // sozinho e o de cima fica cortado. Levar o cabecalho aberto pro topo
        // faz a posicao final ser sempre a mesma, independente do que fechou.
        onOpenStart: (li) => {
          this.scrollSidenavTo(li.querySelector(".collapsible-header"), "start");
        },
      })[0];
    },
    refreshRightNav() {
      var sideRight = document.querySelectorAll(".side-right");
      M.Sidenav.init(sideRight, { edge: "right", draggable: !this.$isApp });
    },
    refreshLeftNav() {
      var sideLeft = document.querySelectorAll(".sidenav-left");
      var instSideLeft = M.Sidenav.init(sideLeft, {
        onOpenStart: this.onOpenLeftNav,
        onCloseStart: this.onCloseLeftNav,
        draggable: !this.$isApp,
      });
      this.leftMenuRef = instSideLeft[0];
    },
    selectClassroomPreview(){
        document.addEventListener('DOMContentLoaded', function() {
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems);
  });
    },
    // Rola o menu lateral ate o alvo (elemento ou seletor) depois que a animacao
    // do accordion termina. Abrir um modulo anima DOIS paineis por 300ms (o alvo
    // expandindo e o anterior colapsando); ler a posicao antes disso da uma
    // coordenada que deixa de valer quando o painel de cima some.
    //
    // O timer nao pode virar `onOpenEnd` do Materialize: aquele callback so roda
    // se a animacao (requestAnimationFrame) completar, e nao roda com a aba em
    // segundo plano — o menu ficaria fora de lugar ao voltar.
    scrollSidenavTo(target, block) {
      clearTimeout(this.sidenavScrollTimer);
      this.sidenavScrollTimer = setTimeout(() => {
        this.sidenavScrollTimer = null;
        var el = typeof target === "string" ? document.querySelector(target) : target;
        if (el) el.scrollIntoView({ block: block || "center", behavior: "smooth" });
      }, 350);
    },
    onOpenLeftNav() {
      if (this.$route.name != "class") {
        clearTimeout(this.sidenavScrollTimer);
        var menuCont = document.querySelectorAll("#sidenav-1");
        menuCont[0].scrollTop = 0;
        return false;
      }

      this.scrollToCurrentLearningObject();
    },

    onCloseLeftNav() {
      if (this.leftMenuAccordionRef) {
        setTimeout(() => {

          this.leftMenuAccordionRef.close(this.leftMenuAccordionIndex);
        }, 200)
      }
    },
    toggleSideMenu() {
      if (!this.isDesktop) return;
      if (this.sidenavIsOpen) this.onCloseLeftNav();
      else this.onOpenLeftNav();

      this.$store.dispatch("config/setSidenavState");
    },
    handleWindowResize() {
      this.isDesktop = window.innerWidth > 1300;
    },
    scrollToCurrentLearningObject() {
      if (!this.selectedEnroll) return;

      var learningObj;

      for (var i = 0; i < this.selectedEnroll.classes.length; i++) {
        const lobj = this.selectedEnroll.classes[i].learningObjects.find(
          (lo) => {
            return lo.id == this.$route.params.id;
          }
        );
        if (lobj) {
          learningObj = lobj;
          break;
        }
      }

      if (!learningObj) return;

      var accordionClass = document.querySelectorAll(
        ".clss-" + learningObj.classId
      )[0];
      // Posição real do LI no accordion (o M.Collapsible abre por índice de
      // filho). O data-accordion-index é o índice no array de turmas e não
      // conta itens extras do menu, como a recomendação de produto.
      this.leftMenuAccordionIndex = Array.prototype.indexOf.call(
        accordionClass.parentNode.children,
        accordionClass
      );
      this.leftMenuAccordionRef.open(this.leftMenuAccordionIndex);
      this.scrollSidenavTo(".lbj-" + learningObj.id);
    },
    menuIcon(learningObj) {
      if (learningObj.forms) {
        if (learningObj.forms.type == "SurveyResearch") return "help_outline";
        if(learningObj.forms.type == 'Proof')
        return 'assignment';
      }
      if (learningObj.externalContent) {
        if(learningObj.externalContent.icon)
          return learningObj.externalContent.icon;
        else
        return "thumb_up";
      }
    },
    clearSearch() {
      this.$store.dispatch("enroll/updateFilter", (this.searchFilter = ""));

      if (this.leftMenuAccordionRef) this.leftMenuAccordionRef.close();

      // fechar o menu
    },
    classRouteActive(clss) {
      if (this.$route.name != "class") return false;

      for (let i in clss) {
        if (
          clss.learningObjects.filter((lObj) => {
            return parseInt(this.$route.params.id) == lObj.id;
          }).length
        ) {
          return true;
        }
      }

      return false;
    },
    lObjActive(lObj) {
      if (this.$route.name != "class") return false;

      return parseInt(this.$route.params.id) == lObj.id;
    },



    formatClassTitle(clss) {
      if (clss.state == "Scheduled" && clss.releasedDate) {
        return " (Liberado em " + formatDate(new Date(clss.releasedDate)) + ")";
      }
      //return clss.title;
    },
    formatLearningObjectTitle(lobj, classState, clssReleasedDate) {
      if (lobj.state == "Scheduled" && lobj.releasedDate) {
        return "liberado em " + formatDate(new Date(lobj.releasedDate));
      }
      return lobj.title;
    },

    formatContentProgress() {
      if (!this.selectedEnroll || !this.selectedEnroll.summary) {
        return "Carregando informações...";
      }

      const summary = this.selectedEnroll.summary;
      const lines = [];

      // Módulos
      if (summary.modulesAmount > 0) {
        lines.push(`${summary.modulesAmount > 1 ? 'Módulos' : 'Módulo'}: ${summary.modulesAmount}/${summary.modulesAmount}`);
      }

      // Disciplinas
      if (summary.disciplinesAmount > 0) {
        lines.push(`${summary.disciplinesAmount > 1 ? 'Disciplinas' : 'Disciplina'}: ${summary.disciplinesAmount}/${summary.disciplinesAmount}`);
      }

      // Aulas
      if (summary.classesAmount > 0) {
        lines.push(`${summary.classesAmount > 1 ? 'Aulas' : 'Aula'}:\n ${this.progressModuleDiscipline(this.selectedEnroll)}\n`);
      }

      // Quizes
      if (summary.quizAmount > 0) {
        lines.push(`${summary.quizAmount > 1 ? 'Quizes' : 'Quiz'}: ${summary.quizAmount}/${summary.quizAmount}`);
      }

      // Objetos de aprendizagem
      if (this.selectedEnroll.totalLearningObjects > 0) {
        lines.push(`${this.selectedEnroll.totalLearningObjects > 1 ? 'Objetos de aprendizagem' : 'Objeto de aprendizagem'}: ${this.progressLObj(this.selectedEnroll)}`);
      }

      // Downloads
      if (summary.filesAmount > 0) {
        lines.push(`${summary.filesAmount > 1 ? 'Downloads' : 'Download'}: ${summary.filesAmount}`);
      }

      // Return empty message if no items
      if (lines.length === 0) {
        return "Nenhum conteúdo disponível";
      }

      return lines.join('\n');
    },

    getClassImage(clss) {
      // Imagem definida pelo produtor sobrescreve a thumb/poster do primeiro vídeo
      if (clss && clss.backgroundImage)
        return this.moduleBackgroundImageUrl(clss.backgroundImage);

      if (!clss || !clss.learningObjects || clss.learningObjects.length == 0)
        return "@/assets/images/default-course-image.png";

      return this.learningObjectImageByType(clss.learningObjects[0]);
    },
    getModuleImage(mod) {
      var img = "@/assets/images/default-course-image.png";
      if (!mod) return img;

      // Imagem definida pelo produtor sobrescreve a thumb/poster do primeiro vídeo
      if (mod.backgroundImage)
        return this.moduleBackgroundImageUrl(mod.backgroundImage);

      if (!mod.classes || mod.classes.length == 0) return img;

      var firstClass = mod.classes[0];

      if (!firstClass) return img;

      if (firstClass.backgroundImage)
        return this.moduleBackgroundImageUrl(firstClass.backgroundImage);

      if (
        !firstClass.learningObjects ||
        firstClass.learningObjects.length == 0
      )
        return img;

      return this.learningObjectImageByType(firstClass.learningObjects[0]);
    },
    moduleBackgroundImageUrl(img) {
      // Campo pode vir como URL completa ou caminho relativo do CDN
      if (img.startsWith("http")) return img;
      return `${process.env.VUE_APP_CDN_URL}${img}`;
    },
    learningObjectImageByType(lo) {
      if (lo.broadcast) return lo.image + "?h=249";

      return lo.image;
    },
    updateFilter(filter) {
      this.shouldMaterializeInit = false;
      this.$store.dispatch("enroll/updateFilter", filter);

      if (this.leftMenuAccordionRef) {
        for (
          var i = 0;
          document.getElementsByClassName("collapsible-body").length > i;
          i++
        ) {
          document
            .getElementsByClassName("collapsible-body")
            [i].setAttribute("style", "display:block");
        }
      }
    },
    async logout() {
      if (this.$isApp) {
        await this.$keychain.clearCredentials().catch(() => {});
      }
      await AuthService.makeLogout();
      window.location.reload();
    },
    finishedLearningObject(progress) {
      return progress == 100;
    },
    // Duração quando existe; senão, o TIPO do conteúdo. Quiz, texto, áudio e PDF
    // não têm duração, e a linha ficava com o espaço da direita vazio — o que
    // lia como informação faltando, não como "esse conteúdo não tem tempo".
    //
    // Só no app: na web a linha é uma só (título à esquerda, duração à direita) e
    // encaixar "Texto" ali competiria com o título. No app o layout é em coluna
    // (duração embaixo do título), e o rótulo ocupa uma linha que já existe.
    learningObjectMeta(learningObject) {
      if (!learningObject) return "";

      const duration = this.getDuration(learningObject.broadcast);
      if (duration) return duration;
      if (!this.$isApp) return "";

      if (learningObject.forms) {
        // Mesmos tipos que o menuIcon distingue.
        if (learningObject.forms.type === "Proof") return "Prova";
        if (learningObject.forms.type === "SurveyResearch") return "Pesquisa";
        return "Quiz";
      }
      if (learningObject.audio) return "Áudio";
      if (learningObject.pdf) return "PDF";
      if (learningObject.htmlContent) return "Leitura";
      if (learningObject.externalContent) return "Link";
      // Vídeo sem duração declarada: melhor não rotular do que rotular errado.
      if (learningObject.broadcast) return "Vídeo";
      return "";
    },
    getDuration(broadcast) {
      if (!broadcast) return "";

      function fmtMSS(s) {
        return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
      } // formata
      return fmtMSS(broadcast.duration);
    },
    finishedTotal(learningObjects) {
      var total = learningObjects.filter((lobj) => {
        return lobj.progress == 100;
      }).length;
      return total;
    },
    progressModuleTotal(clss){
      if (this.finishedTotal(clss.learningObjects) == clss.learningObjects.length){
        return 100;
      }
        return 0;
    },

    progressModuleDiscipline(mod) {
      var total = mod.classes.length;
      var progress = mod.classes.filter((clss) => {
        //quantas classes foram finalizadas
        for (let i in clss.learningObjects) {
          if
            (this.finishedTotal(clss.learningObjects) == clss.learningObjects.length)
          {
            return true;
          }
        }
        return false;
      }).length;
      return progress + "/" + total;
    },
    progressLObj(mod) {
      var total = mod.totalLearningObjects;
      var totalLObj = 0;

      for (let i in mod.classes) {
        for (let j in mod.classes[i].learningObjects) {
              if (mod.classes[i].learningObjects[j].progress == 100) {
                totalLObj++;
              }
          }
      }
      return totalLObj + "/" + total;
    },
    brDate(strDate) {
      var dt = new Date(strDate);
      var dtMonths = [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez",
      ];

      return (
        (dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate()) +
        " de " +
        dtMonths[dt.getMonth()]
      );
    },
    navToCourse(defaultTarget) {
      if (this.isPreview) return;
      const shopwindowId = this.selectedEnroll?.shopWindowId ?? defaultTarget;

      if (shopwindowId) {
        this.leftMenuRef.close()
        ShopWindowsService.setCurrentShopWindow({ id: shopwindowId });
        this.$router.push({ name: 'trustflix' });
      } else {
        this.$router.push({
          name: 'course',
          params: { id: this.selectedEnroll.id }
        });
      }
    },
    navigateToClass(eventData) {
      if (this.isPreview) return;

      this.$router.push({
        name: "class",
        params: {
          enrollId: this.selectedEnroll.id,
          id: eventData.learningObjectId,
        },
      });
    },
    navigateToCourse(eventData) {
      if (this.isPreview) return;

      if (eventData.shopWindowId) {
        ShopWindowsService.setCurrentShopWindow({ id: eventData.shopWindowId });
        return this.$router.push({ name: "trustflix" });
      }

      this.$router.push({
        name: "course",
        params: {
          id: eventData.courseId,
        },
      });
    },
    navTo(path) {
      if (this.isPreview) return;

      if (path == "/p/my-courses") {
        this.$updateTheme({
          darkTheme: false,
          primary: "#0564b1",
          secondary: "#ffffff",
        });
      }

      this.$router.push(path);
          // Hide the header element
          // document.querySelector('header').style.display = 'none';
          // this.$store.dispatch("config/setSidenavState", false);
          // this.$store.state.config.fixedMenu = false;
          // secondaryText: "#333333"
          // onComplete: () => {
          //   // Force re-render after theme update
          //   this.$nextTick(() => {
          //     this.$forceUpdate();
          //   });
          // }
      // else{
      //   document.querySelector('header').style.display = 'block';
      // }

      // document.querySelector('header').style.display = 'none';
      //  this.$nextTick(() => {
      //         this.$forceUpdate();
      //       });
    },
    showModal(name) {
      if (this.isPreview) return;

      this.$modal.show(name);
    },
    async toggleCourseMute() {
      if (this.isPreview || !this.selectedEnroll) return;
      const courseId = this.selectedEnroll.courseId;
      const muting = !this.currentCourseMuted;
      const ok = await this.$store.dispatch(muting ? "push/muteCourse" : "push/unmuteCourse", courseId);
      if (!ok) return;
      this.$store.commit("toast/NEW", {
        type: "success",
        message: muting
          ? "Pronto, você não vai mais receber avisos deste curso. Dá para reativar aqui ou em Configurações."
          : "Avisos deste curso reativados. Você volta a saber quando chegar aula nova e quando responderem você.",
        duration: 5000,
      });
    },
    async progressObjChange(complete, enroll, learningObject, clss) {
      if (this.isPreview) return;
      try {
        await this.$store.dispatch("enroll/setProgress", {
          enrollId: enroll.id,
          courseId: enroll.courseId,
          moduleId: learningObject.moduleId,
          disciplineId: learningObject.disciplineId,
          classId: learningObject.classId,
          learningObjectId: learningObject.id,
          broadcastId: learningObject.broadcast
            ? learningObject.broadcast.id
            : null,
          progress: complete ? 100 : 0,
        });
        this.$store.dispatch("enroll/getCourseProgress", enroll.id);
      } catch (error) {
        this.$store.commit("toast/NEW", {
          type: "error",
          message: error.message,
          suppressOffline: true,
        });
      }
    },
    openLeftMenu(classId) {
      var modulesElements = document.querySelectorAll(".collapsible-left");

      var selectedClassElement = null;

      for (var i = 0; i < modulesElements[0].children.length; i++) {
        if (
          modulesElements[0].children[i].className.indexOf("clss-" + classId) >
          -1
        ) {
          selectedClassElement = modulesElements[0].children[i];
          this.leftMenuAccordionIndex = i;
          break;
        }
      }
      // this.leftMenuRef.open();
      if (!this.isDesktop) {
        this.leftMenuRef.open()
      } else if (!this.sidenavIsOpen) {
        this.$store.dispatch("config/setSidenavState");
        this.onCloseLeftNav()
      } else {
        this.onOpenLeftNav()
      }

      if (this.leftMenuAccordionRef) {
        this.leftMenuAccordionRef.open(this.leftMenuAccordionIndex);

        // Dentro de uma aula, `onOpenLeftNav` acima ja mirou a aula atual, que
        // e um alvo mais preciso que o cabecalho do modulo.
        if (this.$route.name != "class" && selectedClassElement) {
          this.scrollSidenavTo(selectedClassElement.querySelector(".collapsible-header"), "start");
        }
      }
    },
  },
  filters: {
    imageHandler(url) {
      const isStored = url.startsWith('https://');

      return isStored ? url + '?h=35' : url;
    }
  }
};
</script>

<style scoped lang="scss">
  .box-menu-top {
    width: 100%;
    padding: 0 20px;

    .menu-align a.sidenav-trigger {
      margin-left: 0;
    }
  }

  .icon-certificate{
        padding-top: 6px;
  }
</style>

<style lang="scss" >

/* ── Bloco de progresso do curso: ajustes SÓ no app nativo ──────────────
   Gateado em `.is-app` de propósito. O anel e o título usam a MESMA marcação
   no desktop (o resumo lateral é que tem classe própria, .course-summary-popover),
   então sem o gate estes estilos vazariam para a web.
   Tudo aqui é CSS: nenhuma regra nova depende de marcação, para que a ausência
   de .is-app deixe o desktop idêntico ao que era.

   Duas cores do mockup NÃO foram aplicadas — o "68%" e os valores continuam na
   cor do tema em vez de branco. A navbar tem modo claro (#F2F3F7) e branco
   sumiria nele; a hierarquia vem do tamanho e do peso. */
.is-app {
  // Rótulo de seção, não protagonista: antes disputava com o número em 24px bold.
  // A cor sai da primária e vira cinza — só é possível porque agora existe a
  // classe `is-dark` no <html> (themes/index.js); antes, sem saber o modo, um
  // cinza único reprovava em contraste num dos dois fundos.
  .menuTitle {
    font-family: roboto;
    font-size: 15px;
    line-height: 20px;
    color: #5f5f6b !important;
  }

  .popover__wrapper svg {
    width: 80px;
    height: 80px;
  }

  // Track na mesma espessura do progresso. Reusa o url(#gradient), que já carrega
  // a cor primária do produtor — evita cravar hex e seguir o tema de graça.
  // Antes: 2px em #363636, que virava um fio sob uma faixa de 6.5px.
  .popover__wrapper svg circle:first-of-type {
    stroke: url(#gradient);
    stroke-opacity: 0.18;
    stroke-width: 6;
    fill: none;
  }

  .popover__wrapper svg circle:nth-of-type(2) {
    stroke-width: 6;
  }

  // O tamanho vem de style inline no elemento, daí o !important.
  .popover__wrapper svg text {
    font-size: 18px !important;
  }

  // O número é o dado principal: sai da primária para o tom de maior contraste
  // do modo. O fill vem de atributo de apresentação, então CSS sobrepõe sem
  // !important; a cor dos valores vem de :style inline e precisa dele.
  .popover__wrapper svg text {
    fill: #16161c;
  }

  .course-summary .itemSummary .number {
    color: #16161c !important;
  }
}

.is-app.is-dark {
  .menuTitle {
    color: #8a8a94 !important;
  }

  .popover__wrapper svg text {
    fill: #ffffff;
  }

  .course-summary .itemSummary .number {
    color: #ffffff !important;
  }

}

// O scrollSidenavTo usa scrollIntoView, que alinha o alvo à borda do scrollport
// — e o #sidenav-1 começa em y=0, por baixo do notch. Sem isto, abrir um módulo
// (block: 'start') encostava o cabeçalho na status bar: o contador ficava atrás
// da dynamic island e o relógio por cima do título.
//
// scroll-margin é o mecanismo do próprio scrollIntoView pra isso — resolve sem
// tocar no JS e sem mexer no layout do menu. O inset de baixo entra junto porque
// o scrollport também ultrapassa a viewport; com os dois, o 'center' continua
// centrado de verdade em vez de escorregar pra baixo.
// Título à esquerda, botão de curso à direita. `gap` em vez de space-between
// puro para que o botão não encoste no título quando o nome do curso for curto.
.menu-progress-head {
  display: flex;
  align-items: center;
  justify-items: center;
  gap: 10px;
  margin-bottom: 12px;
  flex-wrap: nowrap;

  & > * {
    width: 100%;
  }
}

#sidenav-1 {
  .collapsible-header,
  .learningObjects {
    scroll-margin-top: env(safe-area-inset-top, 0px);
    scroll-margin-bottom: env(safe-area-inset-bottom, 0px);
  }
}

@media screen and (min-width: 1300px) {
  #sidenav-1 {
    transition: transform 300ms ease-in-out;
    top: 64px;
    height: calc(100% - 64px);
    z-index: 989 !important;

    &.sidenav-expanded {
      transform: translateX(0) !important;
    }
  }
}

.ml0 {
  margin-left: 0;
}

.mr1 {
  margin-right: 10px;
}

.classes-list {
  overflow: visible !important;
}

.img-logo-header {
  width: 45vw;
  max-width: 180px;
  height: 45px; /* 80px;*/
  object-fit: contain;
  object-position: left;
  cursor: pointer;
  border-radius: 4px;
}

.img-logo-header-g {
  width: 70vw;
  max-width: 240px;
  height: 120px;
  -o-object-fit: cover;
  object-fit: contain;
}

.menu-right-header-dark {
  background-color: #0d0d13 !important;
}

.menu-right-header-light {
  background-color: #f5f5f5;
}

.imgMaxWidth {
  max-width: 160px;
}

.notificationImg {
  max-width: 96px;
  max-height: 120px;
}

.courseImg {
  // opacity: 0.5;
  filter: grayscale(1) brightness(0.3) blur(2px);
  transition: opacity 0.5s ease-in-out, filter 0.5s ease-in-out;
}

.modules.active .courseImg {
  // opacity: 1;
  filter: grayscale(0) brightness(0.5) blur(2px);
  // border: 1px solid red;
}

/* Sem imagem de fundo (toggle desligado): fundo neutro para dar contraste ao card do módulo */
.module-header .module-header-no-image {
  width: 100%;
  height: 100%;
}

.module-header .no-image-dark {
  background: rgba(255, 255, 255, 0.12);
}

.module-header .no-image-light {
  background: rgba(0, 0, 0, 0.05);
}

/* No tema claro, o texto do módulo é branco (pensado para a imagem escurecida) —
   sem imagem, escurece o texto para garantir a leitura */
.module-header.header-no-image-light .module-name,
.module-header.header-no-image-light .module-qty,
.module-header.header-no-image-light .module-label,
.module-header.header-no-image-light .main-module {
  color: #515151 !important;
}
.modules .main-module .module-info .obj-separator-mod {
  opacity: 0;
}
.modules.active .main-module .module-info .obj-separator-mod {
  opacity: 1;
  transition: opacity 0.4s ease-in-out;
  // filter: grayscale(0);
  // border: 1px solid red;
}

.header {
  z-index: 1;
  padding: 20px 0;
  position: relative;

  .is-active {
    color: #e01b3c;
  }

  a {
    /*color: #000;*/
    text-decoration: none;
  }

  .menu-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .menu {
    font-size: 25px;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;

    li {
      padding: 15px;
    }

    &.side {
      font-size: 15px;

      .logout-button {
        cursor: pointer;
      }
    }
  }
}

.obj-progress {
  margin-right: 0px;
  svg{
    left: -1px !important;
  }
}

.obj-progress-small {
  margin-right: 12px;

    label{
      position: absolute;
      left: -2px;
      top: -2px;

      [type="checkbox"].filled-in + span:not(.lever):after {
        border-radius: 50%;
      }


      [type="checkbox"].filled-in:checked+span:not(.lever):after {
        width: 14px;
        height: 14px;
        top:  3px;
        left: 3px;
      }

      [type="checkbox"].filled-in:not(:checked) + span:not(.lever):after {
          background: transparent;
          border: 0;
          width: 14px;
          height: 14px;
          top:  3px;
          left: 3px;
      }

      [type="checkbox"].filled-in:checked+span:not(.lever):before {
        width: 5px;
        height: 9px;
        top:  2px;
        left: 5px;
        border-top: 2px solid transparent;
        border-left: 2px solid transparent;
        border-right: 2px solid #fff;
        border-bottom: 2px solid #fff;
        transform: rotateZ(37deg);
        transform-origin: 100% 100%;

      }

      [type="checkbox"].filled-in:not(:checked) + span:not(.lever):before {
        width: 5px;
        height: 9px;
        top:  2px;
        left: 5px;
      }

    }
    svg{
      // border: 1px solid rgb(254, 0, 208);
    }


}




.course-summary {
  font-family: roboto;
  font-size: 14px;
  font-weight: 400;
  color: #bfbfbf;
  width: 65%;
  // margin-bottom: 3em;
}

.course-summary-popover {
  font-family: roboto;
  font-size: 14px;
  font-weight: 400;
  color: #bfbfbf;
   width: 100%;
}


.module-info {
  align-items: center;
}

.module-label {
  display: flex;
  align-items: center;
}

.course-summary li, .course-summary-popover li {
  line-height: 8px !important;
}

.search-header {
  width: 50%;
  height: 45px;
  z-index: 99;
  background-color: #131318;
  border-radius: 10px;
  // color: #ff6600;
}
.search-header-div {
  width: 100%;
}

.vue-tooltip {
  z-index: 9999 !important;
}

.collapsible-left{
  border-radius: 10px;
  overflow: hidden;
}

.sidenav .back-to-trustflix-bt, .back-to-trustflix-bt {
  // border-bottom: 0.5px solid rgb(247, 247, 4);
  // padding: unset;
  font-weight: unset;
  // margin-bottom: 24px;
  padding: 0 10px;

  .container {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    height: 3em;

    i {
      padding: 8px 20px 8px 0;
    }
  }
}

.notify {
cursor: pointer;
text-decoration: none;
}

select{
  display: block !important;
}

.selectClassroom{
  width: 175px !important;
  height: 25px;
  padding: 0;
  margin-left: 5px;
  font-size: 14px;
}

.viewClassroom{
  font-size: 14px;
    display: flex;
    flex-direction: row;
    color: black;
    align-items: center;
    height: 35px;
}

.details{

  width: 100%;
  padding: 0 25px 0 25px ;
}

.obj-separator{
  border-left: 1px solid #FFFFFF99;
  // border-radius: 13px;
  height: 45px;
  position: relative;
  left: -29px;
  top: 30px;
}

.obj-details {
  // Filho direto, e não descendente: `.obj-details i` também alcançava o
  // <i> de dentro do DownloadIcon, no fim da linha, empurrando-o 12px e
  // enquadrando-o em 25x16 — enquanto a linha em progresso, que renderiza um
  // <span> de porcentagem no lugar do <i>, ficava onde estava. Era isso que
  // desalinhava a coluna de status.
  > i, > .obj-status {
    font-size: 16px;
    position: relative;
    width: 25px; /*30px;*/
    height: 16px; /*12px;*/
    flex-shrink: 0;
    z-index: 1;
    margin-right: 12px;
  }
}

// Último LO da lista: o `.obj-separator` é omitido via `v-if` (não faz sentido
// desenhar a linha "pra baixo" sem próximo círculo). Mas como o separator
// contribui com 45px de cross-size no flex row, sua AUSÊNCIA fazia o
// `.obj-details` do último item ter altura natural menor que os outros —
// o LO ficava visualmente comprimido.
//
// Pseudo-element invisível replica APENAS a presença estrutural (1px wide,
// 45px tall, no fluxo flex), sem desenhar nada. Mantém o layout consistente
// com mudança mínima e sem mexer no HTML.
.learningObjects:last-of-type .obj-details::after {
  content: '';
  width: 1px;
  height: 45px;
  flex-shrink: 0;
  pointer-events: none;
}
.obj-separator-mod{
  border-left: 2px solid #FFFFFF99 !important;
  // border-radius: 13px;
    height: 101px;
    position: absolute;
    left: 10px;
    top: 20px;
}

.menuTitle{
  color: var(--main-primary, #9747FF);
  font-family: robotobold;
  font-size: 24px;
  line-height: 30px;
}


.groupsTitle{
  font-family: roboto;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
}
.itemSummary{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;

  &.download{
    height: 35px;
    // padding: 8px 0;
    border-radius: 5px;
    text-decoration: underline;
    cursor: pointer;
  }

  .itemDetail{
    display: flex;
    align-items: center;

    span{
      padding-left: 5px;
    }
  }

  .number {
    margin-left: 4px;
  }
}

.iconSummary{
  width: 20px;
  // height: 20px;
  color: #ffffff;
}

.course-progress{
  display: flex;
  align-items: flex-start;
  justify-content: center;
  //width: 35%;
  //padding-left: 15px;

  // min-height: 11em;
}

.progress-box{
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;

  // padding: 0px;
}

.flex-center{
  display: flex;
  justify-content: center;
}
.groupBox{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
}
.groupPlataform{
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 35px;
  // height: 35px;
  border-radius: 5px;
  margin-right: 10px;



  svg{
    width: 28px;
    height: 28px;
  }
}

.groupName{
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  width: 80%;
}


// ---------------------------------------------------------

.popover {
  font-size: 24px;
  line-height: 36px;
  text-decoration: none;
  color: rgb(228, 68, 68);
  text-align: center;
  padding: 15px 0;
}

.popover__wrapper {
  position: relative;
  margin-top: 1.5rem;
  display: inline-block;
}
.popover__content {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  left: 60px;
  transform: translate(0, 10px);
  background-color: #242424;
  padding: 10px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  width: 200px;
  border-radius: 5px;
}
// .popover__content:before {
//   position: absolute;
//   z-index: -1;
//   content: "";
//   right: calc(50% - 10px);
//   top: -8px;
//   border-style: solid;
//   border-width: 0 10px 10px 10px;
//   border-color: transparent transparent #0f0f0f transparent;
//   transition-duration: 0.3s;
//   transition-property: transform;
// }
.popover__wrapper:hover .popover__content {
  z-index: 10;
  opacity: 1;
  visibility: visible;
  transform: translate(0, -20px);
  transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);
}
.popover__message {
  text-align: center;
}

.no-existing-filtered-classes {
  width: 100%;
  padding: 20px 25px 0 60px;
  color: #9747ff;
}

.main-menu i.material-icons {
  height: fit-content;
  line-height: unset;
}


.is-app {
  .progress-box {
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;

    // Rótulo e valor num grid compartilhado por TODAS as linhas: os números
    // passam a se alinhar entre si. Com o space-between de antes a distância
    // variava com o tamanho do rótulo, e "Módulos" quase encostava no valor
    // na largura de um celular.
    .course-summary {
      width: unset;
      display: grid;
      grid-template-columns: 1fr auto;
      row-gap: 8px;
      column-gap: 12px;
      align-items: baseline;
    }

    // display:contents dissolve os wrappers para que rótulo e valor virem
    // filhos diretos do grid acima.
    .course-summary > li,
    .course-summary .itemSummary {
      display: contents;
      line-height: normal !important;
    }

    // Peso, não cor: é o que dá hierarquia entre valor e rótulo sem depender
    // do tema. As cores do mockup (valor branco) não dão — o tema não expõe
    // classe no DOM, só :style inline, então o CSS não sabe se está no claro.
    .course-summary .itemSummary .number {
      margin-left: 0;
      font-variant-numeric: tabular-nums;
      font-weight: 500;
    }

    & > * {
      flex-grow: 1;
    }
  }

  .popover__wrapper {
    margin-top: unset;
    display: flex;
    justify-content: center;

    .popover {
      display: flex;
    }
  }
}

// Produtor desligou a exibição de progresso: sem título e sem anel, os dois
// containers passam a ter um filho só e as regras feitas para dois desalinham
// tudo. O botão ocupa a linha inteira (largura vem do :width no template) e o
// resumo deixa de ser centralizado, encostando à esquerda como qualquer outro
// bloco da gaveta.
//
// Este bloco vive DEPOIS do `.is-app` acima de propósito: as regras de lá
// (`justify-content: center`, `width: unset` no grid do resumo) têm a mesma
// especificidade e venciam pela ordem — a primeira versão deste fix ficou
// inerte no app exatamente por isso.
.details.no-progress {
  .menu-progress-head {
    margin-bottom: 16px;
  }

  .progress-box {
    justify-content: flex-start;
  }

  .course-summary {
    width: 100%;
  }
}

.is-app .details.no-progress {
  .progress-box {
    justify-content: flex-start;
  }

  // Mantém o grid rótulo/valor do app, mas ocupando a linha: valores alinhados
  // à direita do painel, como as demais linhas da gaveta.
  .course-summary {
    width: 100%;
  }
}

</style>
